import { render } from "./CalendarShow.vue?vue&type=template&id=13cbf0b3"
import script from "./CalendarShow.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarShow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Calendar/CalendarShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13cbf0b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13cbf0b3', __exports__)) {
    api.reload('13cbf0b3', __exports__)
  }
  
  module.hot.accept("./CalendarShow.vue?vue&type=template&id=13cbf0b3", () => {
    api.rerender('13cbf0b3', render)
  })

}


export default __exports__